import src from "IMAGE";
export default { src, width: 759, height: 596, blurWidth: 0, blurHeight: 0};
